import baseRoute from '../baseRoute';

export default `${baseRoute}/reportBlock` as const;
